/**
 * ReportTabs — Underline tabs (CR-0015a / Δ-14a).
 *
 * Replaces the Δ-14 green-bar + white-pill design.
 * Clean white background; active tab marked by a 3px orange underline.
 * Inactive tabs: gray text, no underline.
 */
export default function ReportTabs({ value, onChange }) {
  const TABS = [
    { id: "current", label: "Current Date Report" },
    { id: "daywise", label: "Day Wise Report" },
  ];
  return (
    <div
      data-testid="report-tabs"
      className="flex items-stretch w-full bg-white border-b"
      style={{ borderColor: "#E5E7EB" }}
    >
      {TABS.map((t) => {
        const active = value === t.id;
        return (
          <button
            key={t.id}
            data-testid={`report-tab-${t.id}`}
            onClick={() => onChange(t.id)}
            className="flex-1 py-3 text-sm font-semibold transition-colors relative"
            style={{
              color: active ? "#F97316" : "#6B7280",
              fontWeight: active ? 700 : 500,
            }}
          >
            {t.label}
            {active && (
              <span
                data-testid={`report-tab-underline-${t.id}`}
                className="absolute left-0 right-0 -bottom-px mx-auto"
                style={{
                  height: 3,
                  backgroundColor: "#F97316",
                  width: "calc(100% - 24px)",
                  marginLeft: 12,
                  marginRight: 12,
                  borderRadius: 2,
                }}
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
